import axios from "axios";

const baseURL = "/";

export const axiosInstance = axios.create({
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
  withCredentials: true,
  baseURL,
});
